<ion-row>
  <ion-col size="8" class="ion-padding-end">
    <ion-card>
      <ion-card-content class="card-container">
        <ion-row>
          <ion-col size="2" class="border-col"></ion-col>
          <ion-col size="10" class="header">
            {{ LABEL_ROW[0] }}
          </ion-col>
        </ion-row>
        <ion-row>
          <!-- Column 1 (Days of Week)-->
          <ion-col size="2" class="border-col">
            @for (data of daysOfWeek; track data; let i = $index) {
              <div class="card-data-header">
                {{ data }}
              </div>
            }
          </ion-col>

          <!-- Availability Section-->
          <!-- Column 2 ( Status)-->
          <ion-col size="3">
            <div class="card-data-header">
              {{ AVAILABLE_HEADER_COLS[0] }}
            </div>
            @for (data of expandedAvailability; track data) {
              <div class="card-data">
                @switch (data.status) {
                  @case (IMAGE_OPTIONS.ACTIVE) {
                    <img
                      class="select-icons"
                      [src]="IMAGES.ACTIVE"
                      alt="active"
                    />
                  }
                  @case (IMAGE_OPTIONS.DEACTIVATED) {
                    <img
                      class="select-icons"
                      [src]="IMAGES.CANCEL"
                      alt="cancel"
                    />
                  }
                  @default {
                    <div>{{ data.status }}</div>
                  }
                }
              </div>
            }
          </ion-col>

          <!-- Column 3 (Start-End)-->
          <ion-col size="4">
            <ion-row>
              <ion-col size="5" class="p-vertical-0">
                <div class="card-data-header">
                  {{ AVAILABLE_HEADER_COLS[1] }}
                </div>
              </ion-col>
              <ion-col size="2" class="p-vertical-0">
                <!-- Empty header -->
              </ion-col>
              <ion-col size="5" class="p-vertical-0">
                <div class="card-data-header">
                  {{ AVAILABLE_HEADER_COLS[2] }}
                </div>
              </ion-col>
            </ion-row>

            <ion-row>
              @for (data of expandedAvailability; track data) {
                <ion-col size="5" class="ion-no-padding">
                  <div class="card-data">{{ data.times.start }}</div>
                </ion-col>
                <ion-col size="2" class="hv-center ion-no-padding">
                  @if (data.times.start && data.times.end) {
                    -
                  }
                </ion-col>
                <ion-col size="5" class="ion-no-padding">
                  <div class="card-data">{{ data.times.end }}</div>
                </ion-col>
              }
            </ion-row>
          </ion-col>

          <!-- Column 4 (Effective Date)-->
          <ion-col size="3">
            <div class="card-data-header">
              {{ AVAILABLE_HEADER_COLS[3] }}
            </div>
            @for (data of expandedAvailability; track data) {
              <div class="card-data">
                {{ data.effectiveDate }}
              </div>
            }
          </ion-col>
          <!----------------->
        </ion-row>
      </ion-card-content>
    </ion-card>
  </ion-col>
  <ion-col size="4">
    <ion-card>
      <ion-card-content class="card-container">
        <ion-row>
          <ion-col class="header closed-header">{{ LABEL_ROW[1] }}</ion-col>
        </ion-row>
        <ion-row>
          <!-- Closed Section-->
          <!-- Column 5 ( Start-End Date)-->
          <ion-col size="5" offset="1">
            <div class="card-data-header">
              <span>
                {{ CLOSED_HEADER_COLS[0] }}
              </span>
            </div>
            @for (data of expandedCloseDays; track data) {
              <div class="card-data">
                {{ data.start }}
              </div>
            }
          </ion-col>
          <ion-col size="1">
            <div class="card-data-header"></div>
            @for (data of expandedCloseDays; track data) {
              <div class="card-data">
                @if (data.start !== "" && data.end !== "") {
                  -
                }
              </div>
            }
          </ion-col>
          <ion-col size="4">
            <div class="card-data-header">
              <span>
                {{ CLOSED_HEADER_COLS[1] }}
              </span>
            </div>
            @for (data of expandedCloseDays; track data) {
              <div class="card-data">
                {{ data.end }}
              </div>
            }
          </ion-col>
          <!----------------->
        </ion-row>
      </ion-card-content>
    </ion-card>
  </ion-col>
</ion-row>
